import React from 'react';

import InternalRoutes from "./internalRoutes";

const MainRoutes: React.FC = () => {
  return (
    <InternalRoutes />
  );
};

export default MainRoutes;
